module.exports = __webpack_public_path__ + "static/img/bg.7c8b8da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg.png
// module id = C34Q
// module chunks = 1